import UpdateCategoryNameModal from './UpdateCategoryNameModal';

export default UpdateCategoryNameModal;
